import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    List,
    ListItem,
    Paper,
    Typography,
} from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { useAppTranslation } from '../../hooks/useAppTranslation';
import zipStructureImg from '../../../assets/zip_structure.png'; 

export function ZipInfoDialogContent() {
    const { t } = useAppTranslation();

    return (
        <Paper
            elevation={0}
            sx={{
                p: { xs: 2.25, md: 3 },
                borderRadius: '28px',
                border: '1px solid var(--border-color)',
                background: 'var(--surface-gradient)',
                boxShadow: '0 24px 48px rgba(15, 23, 42, 0.08)',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <InfoOutlined sx={{ color: 'var(--accent-color)' }} />
                <Typography variant='h5' sx={{ fontWeight: 800, color: 'var(--text-strong)' }}>
                    {t.zipInfoTitle}
                </Typography>
            </Box>
            <Typography sx={{ mb: 2.5, color: 'var(--text-muted)', lineHeight: 1.7 }}>
                {t.zipInfoDescription}
            </Typography>

            <Box sx={{ width: '100%' }}>
                <Accordion
                    disableGutters
                    sx={{
                        mb: 1.25,
                        borderRadius: '18px !important',
                        overflow: 'hidden',
                        border: '1px solid var(--border-color)',
                        boxShadow: 'none',
                        '&:before': { display: 'none' },
                    }}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: 'var(--text-muted)' }} />} sx={{ backgroundColor: 'var(--surface-muted)' }}>
                        <Typography variant='body1' sx={{ fontWeight: 700, color: 'var(--text-soft)' }}>
                            {t.zipStructureTitle}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <img
                            src={zipStructureImg}
                            alt={t.zipStructureAlt}
                            style={{ maxWidth: '100%', height: 'auto', borderRadius: '14px', border: '1px solid var(--border-color)' }}
                        />
                    </AccordionDetails>
                </Accordion>

                <Accordion
                    disableGutters
                    sx={{
                        borderRadius: '18px !important',
                        overflow: 'hidden',
                        border: '1px solid var(--border-color)',
                        boxShadow: 'none',
                        '&:before': { display: 'none' },
                    }}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: 'var(--text-muted)' }} />} sx={{ backgroundColor: 'var(--surface-muted)' }}>
                        <Typography variant='body1' sx={{ fontWeight: 700, color: 'var(--text-soft)' }}>
                            {t.fileRulesTitle}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <List sx={{ py: 0 }}>
                            {t.fileStructureRules.map((rule, index) => (
                                <ListItem key={index} sx={{ px: 0, alignItems: 'flex-start' }}>
                                    <Typography variant='body1' sx={{ color: 'var(--text-muted)', lineHeight: 1.7 }}>
                                        <strong>{index + 1}.</strong> {rule}
                                    </Typography>
                                </ListItem>
                            ))}
                        </List>
                    </AccordionDetails>
                </Accordion>
            </Box>
        </Paper>
    );
}
